import { Spin } from "antd";
import React from "react";
import { Loading, TransferRequest } from "../../../helpers/shared-interfaces";
import {
  generateNameFromCustomer,
  getTransferOriginAndDestination,
} from "../../../helpers/utilities";
import { ItemClickProps } from "../GlobalFormModal";
import NoData from "../NoData";

type Props = {
  loading: Loading;
  handleRetry: () => void;
  transfers: TransferRequest[];
  onTransferClick: (item: ItemClickProps) => void;
};

export default function Transfers({
  transfers,
  loading,
  handleRetry,
  onTransferClick,
}: Props): JSX.Element {
  return (
    <div className="global-results">
      {loading === Loading.INITIAL ? null : loading === Loading.LOADING ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <Spin size="default" />
          </div>
        </div>
      ) : loading === Loading.ERROR ? (
        <div className="error-container">
          <p>Something went wrong</p>
          <button onClick={handleRetry}>Try again</button>
        </div>
      ) : transfers.length === 0 ? (
        <div className="no-results">
          <NoData />
          <p>No Data</p>
        </div>
      ) : (
        transfers.map((transfer) => (
          <div
            key={transfer.id}
            className="search-result"
            role="presentation"
            onClick={() =>
              onTransferClick({
                id: transfer.id,
                type: "transfer",
                segment: "transfer-requests",
                data: transfer,
              })
            }
          >
            <div className="result-content">
              <div className="result-title">
                {generateNameFromCustomer(transfer.customer)}
              </div>
              <div className="result-details">
                {getTransferOriginAndDestination(transfer)}
              </div>
            </div>
            <span className="right-arrow">→</span>
          </div>
        ))
      )}
    </div>
  );
}
